var identity = identity || {};
(function() {
  'use strict';
  identity.productDataPdf = {
    settings: identity.pdfUtils.settings(),
    _base: null,
    model: {
      get: function( key ) {
        return identity.pdfUtils.model.get( key, identity.productDataPdf.model );
      },
      set: function( key, value ) {
        return identity.pdfUtils.model.set( key, value, identity.productDataPdf.model );
      },
      reset: function() {
        Object.keys( identity.productDataPdf._base ).forEach( ( key ) => {
          identity.productDataPdf.model[key] = identity.productDataPdf._base[key];
        } );
      },
      save: function() {
        let destinationObject = {};
        Object.keys( identity.productDataPdf.model ).forEach( ( key ) => {
          if ( typeof identity.productDataPdf.model[key] !== 'function' ) {
            destinationObject[key] = identity.productDataPdf.model[key];
          }
        } );
        return destinationObject;
      },
      logo: '',
      name: '',
      number: '',
      imageDetails: [],
      imagePrimary: {},
      url: '',
      descriptionLong: '',
      highlightedFeatures: [],
      compositionHeader: '',
      composition: '',
      pdfColors: [],
      brand: '',
      colorVariantText: '',
      sizes: [],
      user: [],
      date: '',
      specs: {},
      transfer: [],
      translations: [],
      features: [],
      certificates: [],
      careSymbols: [],
      colorVariantCount: 0,
      facilities: [],
      productMaterials: [],
    },
    init: function() {
      identity.productDataPdf._base = identity.productDataPdf.model.save();
      identity.productDataPdf.bindEvents();
      identity.productDataPdf.getTranslations();
    },
    bindEvents: function() {
      jQuery( '.js-identity-download-product-sheet' ).on( 'click', function( event ) {
        event.preventDefault();
        identity.pdfUtils.loader( true );
        identity.productDataPdf.productData.get();
      } );
    },
    getTranslations: async () => {
      const translations = await identity.pdfUtils.translations.getValues( {
            disclaimerText: 'PDF Generation OBS Text',
            colorsHeader: 'PDF Generation Color Text',
            featuresHeader: 'PDF Generation Features Text',
            descriptionHeader: 'PDF Generation Description',
            washingHeadwer: 'PDF Generation Washing',
            certificateHeader: 'PDF Generation Certificate',
            weightHeader: 'Weight',
            sizeHeader: 'Size',
            fittingHeader: 'Fit',
            brandHeader: 'PDF Generation - Brand',
            compositionHeader: 'PDF Generation Composition',
            transferHeader: 'PDF Generation Transfer Types',
            productionCountryHeader: 'PDF Generation Production Country',
            productMaterialsHeader: 'Composition and Materials - Product Materials - Label',
            weightUnit: 'WeightUnit - g'
          }
      );
      Object.keys( translations ).forEach( ( key ) => {
        identity.productDataPdf.model.set( `translations.${ key }`, translations[key] );
      } );
    },
    productData: {
      get: function() {
        const data = jQuery( '.js-e-product' ).data();
        data.isPdf = true;
        e4.jsonpublisher.getJsonFromUrl(
            e4.settings.ecom.product.url,
            data,
        ).done( function( jsonData ) {
          identity.productDataPdf.productData.map( jsonData.product );
          identity.productDataPdf.productData.extend();
          identity.pdfUtils.load( identity.productDataPdf.prepareImages.init );
        } );
      },
      extend: function() {
        var secondaryImagesArr = identity.productDataPdf.model.get( 'imageDetails' ),
            careSymbolsArr = identity.productDataPdf.model.get( 'careSymbols' ),
            colorsArr = identity.productDataPdf.model.get( 'pdfColors' ),
            featuresArr = identity.productDataPdf.model.get( 'features' ),
            certificatesArr = identity.productDataPdf.model.get( 'certificates' );

        if ( certificatesArr !== null ) {
          certificatesArr = Object.values( certificatesArr );
        }

        if ( Array.isArray( secondaryImagesArr ) === true ) {
          identity.productDataPdf.model.imageDetails = secondaryImagesArr.reduce( function( obj, item, depth ) {
            if ( item.original !== identity.productDataPdf.model.get( 'imagePrimary' ).original ) {
              obj['index' + depth] = {
                img: item.original,
              };
            }
            return obj;
          }, {} );
        }

        if ( Array.isArray( colorsArr ) === true ) {
          if ( colorsArr.length < identity.productDataPdf.model.get( 'colorVariantCount' ) ) {
            colorsArr.push(
                {
                  Label: identity.productDataPdf.model.get( 'colorVariantText' ),
                  Image: identity.productDataPdf.model.get( 'imagePrimary' ),
                },
            );
          }

          identity.productDataPdf.model.colors = colorsArr.reduce( function( obj, item, depth ) {
            obj['index' + depth] = {
              img: item.Image.original,
              label: item.Label,
            };
            return obj;
          }, {} );
        }

        if ( Array.isArray( careSymbolsArr ) === true ) {
          identity.productDataPdf.model.careSymbols = careSymbolsArr.reduce( function( obj, item, depth ) {
            obj['index' + depth] = {
              img: item.value,
            };
            return obj;
          }, {} );
        }
        if ( featuresArr !== null ) {
          var counter = 0;
          Object.keys( featuresArr ).forEach( ( key ) => {
            if ( featuresArr[key] !== null ) {
              Object.values( featuresArr[key] ).forEach( ( val ) => {

                if ( val !== null && val !== undefined ) {
                  identity.productDataPdf.model.features['index' + counter] = {
                    img: val.icon,
                  };
                }
                counter++;
                delete featuresArr[key];
              } );
            } else {
              delete featuresArr[key];
            }
          } );
        }
        if ( certificatesArr !== null && Array.isArray( certificatesArr ) === true ) {
          identity.productDataPdf.model.certificates = certificatesArr.reduce( function( obj, item, depth ) {
            obj['index' + depth] = {
              img: item.icon,
            };
            return obj;
          }, {} );
        }
      },
      map: function( productData ) {
        var productId = jQuery( '.js-e-product' ).data( 'productId' ),
            extendPdfData = e4.data.get( [productId, 'PdfData'].join( '_' ) );
        Object.assign( productData, extendPdfData );
        for ( var key in productData ) {
          if ( identity.productDataPdf.model.hasOwnProperty( key ) === true ) {
            identity.productDataPdf.model.set( key, productData[key] );
          }
        }
      },
    },
    prepareImages: {
      deferredImages: [],
      init: function() {
        var logo = {
              key: 'logo',
              img: identity.productDataPdf.model.get( 'logo' ),
              size: {
                width: 200,
                height: 0,
              },
            },
            primaryImage = {
              key: 'imagePrimary',
              img: identity.productDataPdf.model.get( 'imagePrimary' ).original,
              size: {
                width: 500,
                height: 0,
              },
            },
            secondaryImages = {
              key: 'imageDetails',
              img: identity.productDataPdf.model.get( 'imageDetails' ),
              size: {
                width: 500,
                height: 0,
              },
            },
            colors = {
              key: 'colors',
              img: identity.productDataPdf.model.get( 'colors' ),
              size: {
                width: 200,
                height: 0,
              },
            },
            features = {
              key: 'features',
              img: identity.productDataPdf.model.get( 'features' ),
              size: {
                width: 50,
                height: 50,
              },
            },
            certificates = {
              key: 'certificates',
              img: identity.productDataPdf.model.get( 'certificates' ),
              size: {
                width: 50,
                height: 50,
              },
            },
            careSymbols = {
              key: 'careSymbols',
              img: identity.productDataPdf.model.get( 'careSymbols' ),
              size: {
                width: 40,
                height: 40,
              },
            },
            userImage = {
              key: 'user.image',
              img: identity.productDataPdf.model.get( 'user.image' ),
              size: {
                width: 200,
                height: 0,
              },
            };
        identity.pdfUtils.loader( true );
        if ( logo.img.indexOf( 'data:image/png;base64' ) === -1 ) {
          identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( logo, false ) );
        }
        if ( userImage.img.indexOf( 'data:image/png;base64' ) === -1 ) {
          identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( userImage, false ) );
        }
        if ( primaryImage.img.indexOf( 'data:image/png;base64' ) === -1 ) {
          identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( primaryImage, false ) );
        }

        if ( Object.keys( secondaryImages.img ).length > 0 ) {
          Object.keys( secondaryImages.img ).forEach( function( imageKey ) {
            if ( imageKey !== undefined && imageKey !== '' ) {
              var imageObj = {
                key: 'imageDetails',
                index: imageKey,
                img: secondaryImages.img[imageKey].img,
                size: secondaryImages.size,
              };
              identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( imageObj, false ) );
            }
          } );
        }

        if ( Object.keys( colors.img ).length > 0 ) {
          Object.keys( colors.img ).forEach( function( imageKey ) {
            if ( imageKey !== undefined && imageKey !== '' ) {
              var imageObj = {
                key: 'colors',
                index: imageKey,
                img: colors.img[imageKey].img === null ? identity.pdfUtils.image.fallback() : colors.img[imageKey].img,
                size: colors.size,
              };
              identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( imageObj, false ) );
            }
          } );
        }

        if ( careSymbols.img !== null && Object.keys( careSymbols.img ).length > 0 ) {
          Object.keys( careSymbols.img ).forEach( function( imageKey ) {

            if ( imageKey !== undefined && imageKey !== '' ) {
              var imageObj = {
                key: 'careSymbols',
                index: imageKey,
                img: '/files/images/products/WashIcon/' + careSymbols.img[imageKey].img.replace( ',', '' ) + '.svg',
                size: careSymbols.size,
              };
              identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( imageObj, true ) );
            }
          } );
        }

        if ( certificates.img !== null && Object.keys( certificates.img ).length > 0 ) {
          Object.keys( certificates.img ).forEach( function( imageKey ) {
            if ( imageKey !== undefined && imageKey !== '' ) {
              var imageObj = {
                key: 'certificates',
                index: imageKey,
                img: certificates.img[imageKey].img,
                size: certificates.size,
              };
              identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( imageObj, false ) );

            }
          } );
        }

        if ( Object.keys( features.img ).length > 0 ) {

          Object.keys( features.img ).forEach( function( imageKey ) {

            if ( imageKey !== undefined && imageKey !== '' && features.img[imageKey].img !== null ) {
              var imageObj = {
                key: 'features',
                index: imageKey,
                img: features.img[imageKey].img,
                size: features.size,
              };
              identity.productDataPdf.prepareImages.deferredImages.push( identity.productDataPdf.prepareImages.load( imageObj, true ) );
            }
          } );
        }

        jQuery.when.apply( null, identity.productDataPdf.prepareImages.deferredImages ).done( function() {
          identity.productDataPdf.prepareImages.deferredImages = [];
          identity.productDataPdf.build();
        } );
      },
      load: function( imageObj, isSvg ) {
        var image = new Image(),
            deferred = jQuery.Deferred();
        if ( isSvg === true ) {
          var serializer = new XMLSerializer();
          jQuery.when( identity.deferImages.convertSvg( imageObj.img ) ).done( function( svg ) {
            var cleanedSvg = identity.productDataPdf.prepareImages.updateSvg( svg.get( 0 ) );
            identity.productDataPdf.prepareImages.insertIntoModel( imageObj, serializer.serializeToString( cleanedSvg ) );
            deferred.resolve();
          } );
        } else {
          image.onload = function() {
            var canvas = document.createElement( 'canvas' );
            canvas.width = this.naturalWidth === 0 ? imageObj.size.width : this.naturalWidth;
            canvas.height = this.naturalHeight === 0 ? imageObj.size.height : this.naturalHeight;
            canvas.getContext( '2d' ).drawImage( this, 0, 0 );
            imageObj.size.width = image.width;
            imageObj.size.height = image.height;
            identity.productDataPdf.prepareImages.insertIntoModel( imageObj, canvas.toDataURL() );

            deferred.resolve();
          };
          image.onerror = function() {
            var fallbackImage = identity.pdfUtils.image.fallback();
            identity.productDataPdf.prepareImages.insertIntoModel( imageObj, fallbackImage );
            deferred.resolve();
          };
          if ( navigator.userAgent.toLowerCase().indexOf( 'firefox' ) > -1 ) {
            image.width = imageObj.size.width;
            image.height = imageObj.size.height;
          }
          image.src = identity.pdfUtils.image.handler( imageObj.img, imageObj.size );
        }

        return deferred.promise();
      },
      insertIntoModel: function( imageObj, dataUri ) {
        if ( imageObj.index ) {
          identity.productDataPdf.model.set( imageObj.key + '.' + imageObj.index + '.img', dataUri );
          identity.productDataPdf.model.set( imageObj.key + '.' + imageObj.index + '.size.width', imageObj.size.width );
          identity.productDataPdf.model.set( imageObj.key + '.' + imageObj.index + '.size.height', imageObj.size.height );
        } else {
          identity.productDataPdf.model.set( imageObj.key, dataUri );
        }
      },
      updateSvg: function( svg ) {
        var elements = svg.querySelectorAll( 'path, polyline, polygon' );

        for ( var i = 0; i < elements.length; i++ ) {
          elements[i].setAttribute( 'style', 'fill:#6D6F70!important' );
        }
        return svg;
      },
    },
    constructor: {
      color: function() {
        return identity.productDataPdf.model.get( 'imagePrimary' );
      },
      packs: function() {
        var bodyData = [],
            dataRow = [],
            counter = 1,
            packs = identity.productDataPdf.model.get( 'colors' ),
            flags = {};
        if ( jQuery.isEmptyObject( packs ) === false ) {
          jQuery.each( packs, function( key ) {
            dataRow.push( [
              identity.pdfUtils.build.image( packs[key].img, 40, [0, 0, 0, 0], 'center' ), {
                text: packs[key].label, style: {
                  fontSize: 8,
                  color: '#888',
                  bold: false,
                  alignment: 'center',
                },
              }] );
            if ( counter % identity.productDataPdf.settings.packs.colsPerRow === 0 ) {
              bodyData.push( dataRow );
              dataRow = [];
            }
            flags[packs[key].label] = true;
            counter++;
          } );

          if ( dataRow.length ) {
            bodyData.push( dataRow );
          }

          bodyData.forEach( function( element ) {
            if ( element.length < identity.productDataPdf.settings.packs.colsPerRow ) {
              while ( element.length < identity.productDataPdf.settings.packs.colsPerRow ) {
                element.push( '' );
              }
            }
          } );
        } else {
          bodyData.push( identity.pdfUtils.fillArray( '', identity.productDataPdf.settings.packs.colsPerRow ) );
        }

        return bodyData;
      },
      mainImages: function() {
        var columns = [],
            stacks = [],
            detailImages = identity.productDataPdf.model.get( 'imageDetails' ),
            counter = 0;

        columns.push( identity.pdfUtils.build.image( identity.productDataPdf.model.get( 'imagePrimary' ), 190, [0, 0, 0, 0], 'left' ) );

        jQuery.each( detailImages, function( key ) {
          if ( counter < 2 ) {
            stacks.push( identity.pdfUtils.build.image( detailImages[key].img, 80, [0, 10, 0, 0] ) );
          }

          counter++;
        } );
        columns.push( {
          stack: stacks,
        } );
        //return bodyData;
        return columns;
      },
      certificates: function() {
        var bodyData = [],
            dataRow = [],
            counter = 1,
            alignmentCounter = 1,
            certificates = identity.productDataPdf.model.get( 'certificates' );
        if ( jQuery.isEmptyObject( certificates ) === false ) {
          var alignment = 'left';

          jQuery.each( certificates, function( key ) {
            var ratio = Math.min( identity.productDataPdf.settings.certificates.iconSize / certificates[key].size.width,
                    identity.productDataPdf.settings.certificates.iconSize / certificates[key].size.height ),
                height = certificates[key].size.height * ratio,
                marginTop = (identity.productDataPdf.settings.certificates.iconSize - height) / 2;

            switch ( alignmentCounter ) {
              case 1:
                alignment = 'left';
                break;
              case 2:
                alignment = 'center';
                break;
              case 3:
                alignment = 'right';
                break;
            }

            var imageObj = identity.pdfUtils.build.image(
                certificates[key].img,
                75,
                [0, marginTop, 0, 0],
                alignment,
            );

            dataRow.push( [imageObj] );

            if ( counter % identity.productDataPdf.settings.certificates.colsPerRow === 0 ) {
              bodyData.push( dataRow );
              dataRow = [];
              alignmentCounter = 0;
            }
            alignmentCounter++;
            counter++;
          } );

          if ( dataRow.length ) {
            bodyData.push( dataRow );
          }

          bodyData.forEach( function( element ) {
            if ( element.length < identity.productDataPdf.settings.certificates.colsPerRow ) {
              while ( element.length < identity.productDataPdf.settings.certificates.colsPerRow ) {
                element.push( '' );
              }
            }
          } );
        } else {
          bodyData.push( identity.pdfUtils.fillArray( '', identity.productDataPdf.settings.certificates.colsPerRow ) );
        }

        return bodyData;
      },

      features: function() {
        var bodyData = [],
            dataRow = [],
            counter = 1,
            alignmentCounter = 1,
            features = identity.productDataPdf.model.get( 'features' ),
            hasValues = Object.values( identity.productDataPdf.model.get( 'features' ) ).filter( function( feature ) {
              return feature.img !== null;
            } ).length > 0;

        if ( jQuery.isEmptyObject( features ) === false && hasValues === true ) {
          var alignment = 'left';

          jQuery.each( features, function( key ) {

            switch ( alignmentCounter ) {
              case 1:
                alignment = 'left';
                break;
              case 2:
                alignment = 'center';
                break;
              case 3:
                alignment = 'right';
                break;
            }

            var imageObj = identity.pdfUtils.build.svg(
                features[key].img,
                75,
                [0, 0, 0, 0],
                alignment,
            );

            dataRow.push( [imageObj] );
            if ( counter % identity.productDataPdf.settings.features.colsPerRow === 0 ) {
              bodyData.push( dataRow );
              dataRow = [];
              alignmentCounter = 0;
            }
            alignmentCounter++;
            counter++;
          } );

          if ( dataRow.length ) {
            bodyData.push( dataRow );
          }

          bodyData.forEach( function( element ) {
            if ( element.length < identity.productDataPdf.settings.features.colsPerRow ) {
              while ( element.length < identity.productDataPdf.settings.features.colsPerRow ) {
                element.push( '' );
              }
            }
          } );
        } else {
          bodyData.push( identity.pdfUtils.fillArray( '', identity.productDataPdf.settings.features.colsPerRow ) );
        }

        return bodyData;
      },
      specs: function() {
        var bodyData = [],
            specs = identity.productDataPdf.model.get( 'specs' ),
            specWeight = specs.fields.find( function( obj ) {
              return obj.id.indexOf( 'gm2' ) > -1;
            } ),
            specFit = specs.fields.find( function( obj ) {
              return obj.id === 'StyleFit';
            } ),
            composition = identity.productDataPdf.model.get( 'composition' ),
            transfer = identity.productDataPdf.model.get( 'transfer' ),
            sizes = identity.productDataPdf.model.get( 'sizes' ),
            brand = identity.productDataPdf.model.get( 'brand' ),
            sizeSpan = sizes.length === 1 ? sizes[0] : sizes[0] + ' - ' + sizes[sizes.length - 1],
            careSymbolsArr = identity.productDataPdf.model.get( 'careSymbols' ),
            facilities = identity.productDataPdf.model.get( 'facilities' ),
            facility = facilities.length > 0 ? facilities[0] : null,
            productMaterials = identity.productDataPdf.model.get( 'productMaterials' );

        if ( composition ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.compositionHeader' ),
              style: 'specBold',
            }, {
              text: composition,
              style: 'spec',
            }] );
        }
        if ( specWeight ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.weightHeader' ),
              style: 'specBold',
            }, {
              text: specWeight.value + ' ' + identity.productDataPdf.model.get( 'translations.weightUnit' ),
              style: 'spec',
            }] );
        }
        if ( sizeSpan ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.sizeHeader' ),
              style: 'specBold',
            }, {
              text: sizeSpan,
              style: 'spec',
            }] );
        }
        if ( specFit ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.fittingHeader' ),
              style: 'specBold',
            }, {
              text: specFit.value,
              style: 'spec',
            }] );
        }

        if ( brand !== '' ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.brandHeader' ),
              style: 'specBold',
            }, {
              text: brand,
              style: 'spec',
            }] );
        }

        if ( jQuery.isEmptyObject( careSymbolsArr ) === false ) {
          var careRow = [];
          jQuery.each( careSymbolsArr, function( key ) {
            careRow.push( identity.pdfUtils.build.svg( careSymbolsArr[key].img, 15 ) );
          } );
          var column = {
            columns: careRow,
            columnGap: 2,
          };
          if ( careRow.length ) {
            bodyData.push( [
              {
                text: identity.productDataPdf.model.get( 'translations.washingHeadwer' ),
                style: 'specBold',
              }, column] );
          }

        }

        if ( transfer.length > 0 ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.transferHeader' ),
              style: 'specBold',
            }, {
              text: transfer.map( function( t ) {
                return t.Name;
              } ).join( ', ' ),
              style: 'spec',
            }] );
        }
        if ( facility !== null ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.productionCountryHeader' ),
              style: 'specBold',
            }, {
              text: facility.Country !== '' ? facility.Country : '-',
              style: 'spec',
            }] );
        }

        if ( productMaterials.length > 0 ) {
          bodyData.push( [
            {
              text: identity.productDataPdf.model.get( 'translations.productMaterialsHeader' ),
              style: 'specBold',
            }, {
              text: productMaterials.join( '\r\n' ),
              style: 'spec',
            }] );
        }

        return bodyData;
      },
      rightColumn: function() {
        var hasColorPacks = jQuery.isEmptyObject( identity.productDataPdf.model.get( 'colors' ) ) === false,
            colorPacks = [
              {
                text: identity.productDataPdf.model.get( 'translations.colorsHeader' ),
                style: 'header',
                margin: [32, 17, 0, 10],
              }, {
                margin: [32, 0, 0, 0],
                layout: identity.pdfUtils.cleanTableLayout(),
                table: {
                  widths: identity.pdfUtils.fillArray( '*', identity.productDataPdf.settings.packs.colsPerRow ),
                  body: identity.productDataPdf.constructor.packs(),
                },

              }];

        if ( hasColorPacks === false ) {
          colorPacks = '';
        }

        var descriptionObj = {
          text: identity.productDataPdf.model.get( 'descriptionLong' ),
          margin: [32, 0, 15, 0],
          style: 'small',
          alignment: 'left',
        };

        var highlights = identity.productDataPdf.model.get( 'highlightedFeatures' );
        var hasFeatures = Object.values( identity.productDataPdf.model.get( 'features' ) ).filter( function( feature ) {
          return feature.img !== null;
        } ).length > 0;
        var certificates = identity.productDataPdf.model.get( 'certificates' );
        ;
        var hasCertificates = jQuery.isEmptyObject( certificates ) === false;

        if ( highlights.length > 0 ) {
          descriptionObj = {
            ul: highlights,
            margin: [32, 0, 15, 0],
            style: 'small',
            alignment: 'left',
          };
        }

        return [
          colorPacks,
          {
            text: identity.productDataPdf.model.get( 'translations.descriptionHeader' ),
            style: 'header',
            margin: [32, (hasColorPacks ? 20 : 0), 0, 10],
          },
          descriptionObj,
          hasCertificates ? {
            text: identity.productDataPdf.model.get( 'translations.certificateHeader' ),
            style: 'header',
            margin: [32, 20, 0, 10],
          } : '',
          hasCertificates ? {
            margin: [32, 0, 0, 0],
            layout: identity.pdfUtils.cleanTableLayout(),
            table: {
              widths: identity.pdfUtils.fillArray( '*', identity.productDataPdf.settings.certificates.colsPerRow ),
              body: identity.productDataPdf.constructor.certificates(),
            },
          } : '',
          hasFeatures ? {
            text: identity.productDataPdf.model.get( 'translations.featuresHeader' ),
            style: 'header',
            margin: [32, 10, 0, 10],
          } : '',
          hasFeatures ? {
            margin: [32, 0, 0, 0],
            layout: identity.pdfUtils.cleanTableLayout(),
            table: {
              widths: identity.pdfUtils.fillArray( '*', identity.productDataPdf.settings.features.colsPerRow ),
              body: identity.productDataPdf.constructor.features(),
            },
          } : '',
        ];

      },
      leftColumn: function() {
        return [
          {
            layout: identity.pdfUtils.cleanTableLayout(),
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    columns: [
                      identity.pdfUtils.build.image( identity.productDataPdf.constructor.color(), 12, [0, 0, 10, 0] ),
                      {
                        text: identity.productDataPdf.model.get( 'colorVariantText' ),
                        fontSize: 10,
                        margin: [10, 0, 0, 10],
                      },
                    ],
                    margin: [0, 10, 0, 10],
                  },
                ],
              ],
            },
          },
          {
            columns: identity.productDataPdf.constructor.mainImages(),
          },
          {
            margin: [0, 20, 0, 0],
            table: {
              widths: ['*', '*'],
              body: identity.productDataPdf.constructor.specs(),
            },
            layout: {
              paddingLeft: function() {
                return 5;
              },
              paddingRight: function() {
                return 5;
              },
              paddingTop: function() {
                return 8;
              },
              paddingBottom: function() {
                return 8;
              },
              hLineColor: function() {
                return '#888';
              },
              vLineWidth: function( i ) {
                return 0;
              },
              vLineColor: function() {
                return '#888';
              },
            },
          },
          {
            text: identity.productDataPdf.model.get( 'translations.disclaimerText' ),
            style: 'disclaimerText',
            margin: [5, 15, 0, 10],
          },
        ];
      },

    },
    build: async function() {
      let titleFontSize = 22;
      const titleWidth = await identity.pdfUtils.measureText( identity.productDataPdf.model.get( 'name' ), {
        fontSize: titleFontSize,
      } );
      if ( titleWidth > 340 ) {
        titleFontSize = await identity.pdfUtils.resizeText( identity.productDataPdf.model.get( 'name' ), titleFontSize, 350 );
      }
      var arrPdf = [],
          objContent = [
            {
              text: identity.productDataPdf.model.get( 'date' ), style: 'date', margin: [0, 0, 0, 30],
            },
            identity.pdfUtils.build.cornerBracket( 'top', { x: 0, y: -2 } ),
            identity.pdfUtils.build.cornerBracket( 'bottom', { x: 0, y: 25 } ),
            {
              layout: identity.pdfUtils.cleanTableLayout(),

              table: {
                widths: ['auto', '*', 50],

                body: [
                  [
                    {
                      text: `NO. ${ identity.productDataPdf.model.get( 'number' ) }`,
                      style: 'productNumber',
                      margin: [8, 2, 0, 20],
                    },
                    {
                      text: identity.productDataPdf.model.get( 'name' ),
                      style: {
                        fontSize: titleFontSize,
                        bold: true,
                        alignment: 'left',
                      },
                      margin: [8, (22 - titleFontSize), 0, 20],
                    },
                    identity.pdfUtils.build.image( identity.productDataPdf.model.get( 'logo' ), 50, [0, -10, 0, 0] ),
                  ],
                ],
              },
            },
            identity.pdfUtils.build.line(),
            {
              layout: identity.pdfUtils.cleanTableLayout(),
              table: {
                widths: ['*', '*'],
                body: [
                  [
                    identity.productDataPdf.constructor.leftColumn(),
                    identity.productDataPdf.constructor.rightColumn(),

                  ],
                ],
              },
            },
          ];
      arrPdf.push( objContent );
      identity.productDataPdf.create( arrPdf );
    },
    create: function( arrPdf ) {
      pdfMake.fonts = identity.pdfUtils.setFont();
      var docDefinition = {
            pageSize: 'A4',
            pageMargins: identity.productDataPdf.settings.pageMargins,
            content: arrPdf,
            fonts: identity.pdfUtils.setFont(),
            defaultStyle: {
              font: identity.productDataPdf.settings.defaultFont,
            },
            footer: identity.pdfUtils.build.footer(),
            styles: identity.pdfUtils.styles.default(),
          },
          pdfDocGenerator = pdfMake.createPdf( docDefinition, null, identity.pdfUtils.setFont() );
      pdfDocGenerator.download( identity.productDataPdf.model.get( 'name' ).replace( / /g, '_' ) + '.pdf' );
      pdfDocGenerator.getDataUrl( function() {
        identity.pdfUtils.loader( false );
        identity.productDataPdf.model.reset();
      } );
    },
  };
}());
